// extracted by mini-css-extract-plugin
export default {"page":"XP6ti","title":"yin9S"};